import { __assign, __extends } from "tslib";
import * as React from 'react';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Bar, BarChart, Cell, ReferenceLine, ReferenceArea } from 'recharts';
import { CustomizedXAxisTick } from './customized-x-axis-tick';
import { namespacedClassnames } from '../../common';
import { Tooltip as LibbyTooltip } from '../../primitives/tooltip/tooltip';
import { Text } from '../../new-libby/core/typography';
export var BarGraphKey = 'bar-graph';
export var BARS_GAP = 20;
export var BAR_WIDTH_NORMAL = 600;
export var BAR_WIDTH_EXPENDED = 1100;
var BarGraph = /** @class */ (function (_super) {
    __extends(BarGraph, _super);
    function BarGraph() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeDataIndex: undefined,
            tooltipXCoordinate: 0,
            xAxisTooltipCoordinate: 0,
            offset: 0,
        };
        _this.ref = React.createRef();
        _this.handleMouseMove = function (data) {
            if (!data.isTooltipActive) {
                _this.setState({ activeDataIndex: undefined });
            }
            else if (data.activeTooltipIndex >= 0) {
                _this.setState({
                    activeDataIndex: data.activeTooltipIndex,
                    tooltipXCoordinate: data.activeCoordinate.x
                });
            }
        };
        _this.handleMouseLeave = function () { return _this.setState({ activeDataIndex: undefined }); };
        _this.renderChartBars = function () {
            var props = _this.props;
            var dataSize = props.data.length;
            var width = props.isExpanded ? BAR_WIDTH_EXPENDED : BAR_WIDTH_NORMAL;
            var barWidthcalc = (width - BARS_GAP * dataSize - 3) / (dataSize + 3);
            var finalWidth = barWidthcalc > 30 ? 30 : barWidthcalc < 3 ? 3 : barWidthcalc;
            return (React.createElement(Bar, { className: 'chart-bar', dataKey: 'value', barSize: finalWidth, background: props.withBackground }, _this.props.data.map(function (line) { return React.createElement(Cell, { key: line.name, fill: line.color }); })));
        };
        _this.renderCompareChartBar = function () {
            var props = _this.props;
            var dataSize = _this.props.data.length;
            var width = props.isExpanded ? BAR_WIDTH_EXPENDED : BAR_WIDTH_NORMAL;
            var barWidthcalc = (width - BARS_GAP * dataSize - 3) / (dataSize + 3);
            var finalWidth = barWidthcalc > 30 ? 10 : barWidthcalc < 3 ? 1 : barWidthcalc / 3;
            return (React.createElement(Bar, { className: 'chart-bar', label: false, dataKey: 'compareVal', barSize: finalWidth }, props.data.map(function (line) { return React.createElement(Cell, { key: line.name, fill: line.color + '80' }); })));
        };
        _this.renderTooltip = function () {
            var _a = _this, state = _a.state, props = _a.props;
            if (state.activeDataIndex === undefined) {
                return null;
            }
            var getBarObj = _this.ref.current ?
                _this.ref.current.querySelectorAll('.recharts-bar-rectangle')[state.activeDataIndex].firstChild
                : null;
            var tooltipHeight = Math.round(getBarObj ? getBarObj.getAttribute('height') : 0);
            var ttStyle = {
                transform: "translateX(" + state.tooltipXCoordinate + "px) translateX(-5%) ",
                bottom: tooltipHeight + 50 + "px",
            };
            var activeX = state.activeDataIndex >= 0 ? state.activeDataIndex : -1;
            var topTooltipItems = (React.createElement("div", { key: activeX, className: 'tooltip-item' }, props.tooltipLabel(activeX)));
            var onEnter = function () { return _this.setState({ activeDataIndex: _this.state.activeDataIndex }); };
            var onLeave = function () { return _this.setState({ activeDataIndex: undefined }); };
            return (React.createElement("div", { className: namespacedClassnames('bar-chart-vertical-tooltip'), onMouseLeave: onLeave, onMouseEnter: onEnter, style: ttStyle },
                React.createElement(LibbyTooltip, { relativeToBody: true, direction: 'top', forceVisible: true, body: topTooltipItems },
                    React.createElement("div", null))));
        };
        _this.onEnterXTick = function (axisVal) {
            _this.setState({ activeXTick: axisVal.value, offset: axisVal.offset, xAxisTooltipCoordinate: axisVal.coordinate });
        };
        _this.exitXTick = function () {
            _this.setState({ activeXTick: undefined, xAxisTooltipCoordinate: 0 });
        };
        _this.xAxisTooltip = function (value) {
            var state = _this.state;
            var ttStyle = {
                transform: "translateX(" + state.xAxisTooltipCoordinate + "px) translateX(-50%)",
                bottom: 48,
            };
            var onEnter = function () { return _this.setState({
                activeXTick: state.activeXTick, xAxisTooltipCoordinate: state.xAxisTooltipCoordinate
            }); };
            var xAxisToolbody = React.createElement(Text, { type: 'ts', color: 't40' }, value);
            /* tslint:disable */
            return value.length > 10 ? (React.createElement("div", { onMouseEnter: onEnter, onMouseLeave: _this.exitXTick, className: 'xaxis-tool', style: ttStyle },
                React.createElement(LibbyTooltip, { body: xAxisToolbody, direction: 'top', className: 'x-axis-tooltip-body', forceVisible: true },
                    React.createElement("div", null)))) : '';
            /* tslint:enable */
        };
        _this.renderThresholdLable = function () {
            var props = _this.props;
            return (React.createElement("text", { className: 'threshold-lable', style: { fill: props.threshold ? props.threshold.color : 'white' } },
                React.createElement("tspan", { className: 'lable-span', x: '45', y: 100 }, _this.props.threshold ? _this.props.threshold.from : '')));
        };
        _this.renderThreshold = function () {
            var props = _this.props;
            if (props.threshold) {
                return ([
                    (React.createElement("defs", null,
                        React.createElement("linearGradient", { id: 'bar-gradient-area', x2: '0', y2: '1' },
                            React.createElement("stop", { offset: '0%', stopOpacity: '0', stopColor: props.threshold.color }),
                            React.createElement("stop", { offset: '100%', stopOpacity: '0.2', stopColor: props.threshold.color })))), (React.createElement(ReferenceLine, { y: props.threshold.from, stroke: props.threshold.color, label: _this.renderThresholdLable, strokeDasharray: '3 3', isFront: true })), (React.createElement(ReferenceArea, { y1: props.threshold.from, stroke: 'none', strokeDasharray: '3 3' }))
                ]);
            }
            else {
                return [];
            }
        };
        return _this;
    }
    BarGraph.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.ref.current && _this.props.threshold) {
                var getY = _this.ref.current.querySelectorAll('.recharts-reference-line-line')[0].getAttribute('y1');
                var yVal = getY ? Number(getY) + 4 : 0;
                _this.ref.current.querySelectorAll('.lable-span')[0].setAttribute('y', "" + yVal);
            }
            _this.props.data.map(function (line, idx) {
                var bar = _this.ref.current ? _this.ref.current.querySelectorAll('.recharts-bar-background-rectangle')[idx] : null;
                var color = bar ? bar.getAttribute('color') : '';
                if (line.color === color && bar) {
                    bar.setAttribute('fill', color + 80);
                }
            });
            return;
        }, 200);
    };
    BarGraph.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.data !== this.props.data) {
            if (this.ref.current && this.props.threshold) {
                var getY = this.ref.current.querySelectorAll('.recharts-reference-line-line')[0].getAttribute('y1');
                var yVal = getY ? Number(getY) + 4 : 0;
                this.ref.current.querySelectorAll('.lable-span')[0].setAttribute('y', "" + yVal);
            }
            this.props.data.map(function (line, idx) {
                var bar = _this.ref.current ? _this.ref.current.querySelectorAll('.recharts-bar-background-rectangle')[idx] : null;
                var color = bar ? bar.getAttribute('color') : '';
                if (line.color === color && bar) {
                    bar.setAttribute('fill', color + 80);
                }
            });
        }
    };
    BarGraph.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var areaChartMargin = { top: 10, right: 10, bottom: 30, left: 10 };
        var areaChartProps = {
            data: props.data,
            onMouseMove: this.handleMouseMove,
            onMouseLeave: this.handleMouseLeave,
            barGap: 3,
            barCategoryGap: BARS_GAP,
            margin: areaChartMargin,
        };
        /* tslint:disable */
        return (React.createElement("div", { className: namespacedClassnames(BarGraphKey), ref: this.ref },
            this.renderTooltip(),
            state.activeXTick ? this.xAxisTooltip(state.activeXTick) : null,
            React.createElement(ResponsiveContainer, { width: props.width || '99%', height: props.height || 400 },
                React.createElement(BarChart, __assign({}, areaChartProps, { width: 500 }),
                    React.createElement(CartesianGrid, { stroke: '#dfe5eb', strokeDasharray: '2 2', vertical: false }),
                    React.createElement(XAxis, { interval: 0, tick: React.createElement(CustomizedXAxisTick, null), tickLine: false, dataKey: 'name', axisLine: { stroke: '#dfdfdf' }, onMouseOver: this.onEnterXTick, onMouseOut: this.exitXTick }),
                    React.createElement(YAxis, { tickFormatter: props.yAxisTickLabel, tickLine: false, axisLine: { stroke: '#dfdfdf' }, tick: { fill: '#577083', fontSize: '12', opacity: 0.77 } }),
                    React.createElement(Tooltip, { content: React.createElement("span", null), cursor: false }),
                    this.renderChartBars(),
                    this.renderCompareChartBar(),
                    this.renderThreshold()))));
        /* tslint:enable */
    };
    return BarGraph;
}(React.Component));
export { BarGraph };
//# sourceMappingURL=index.js.map